import { render, staticRenderFns } from "./WaitingToBeSentApplication.vue?vue&type=template&id=2aed82a1&"
import script from "./WaitingToBeSentApplication.vue?vue&type=script&lang=js&"
export * from "./WaitingToBeSentApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports